import { gql } from '@apollo/client';
/**
 * @const ImportSaleItemOptionsMutation
 * @since 1.0.0
 */
export const ImportSaleItemOptionsMutation = gql `
  mutation ImportSaleItemOptionsMutation($input: ImportSaleItemOptionsInput!) {
    importSaleItemOptions(input: $input)
  }
`;
